import React from 'react';
import {
	Button,
	Checkbox,
	Form,
	Icon,
	Input,
	message,
	Dropdown,
	DatePicker,
	Menu,
	Upload,
	Select,
	Col,
	Layout,
	Row
} from 'antd';
import { Redirect } from 'react-router-dom';
import { Link } from 'react-router-dom';
import * as moment from 'moment';
import { auth, database } from '../firebase/firebase';
import HorizontalDefault from "./Topbar/HorizontalDefault/index";
import Moment from "moment";
import {version} from "util/config";

import { connect } from 'react-redux';
import {
	hideMessage,
	showAuthLoader,
	userFacebookSignIn,
	userGithubSignIn,
	userGoogleSignIn,
	userSignUp,
	userSignIn,
	userTwitterSignIn
} from 'appRedux/actions/Auth';

import IntlMessages from 'util/IntlMessages';
import CircularProgress from 'components/CircularProgress/index';


const FormItem = Form.Item;
const Option = Select.Option;

function getBase64(img, callback) {
	const reader = new FileReader();
	reader.addEventListener('load', () => callback(reader.result));
	reader.readAsDataURL(img);
}

function beforeUpload(file) {
	const isJPG = file.type === 'image/jpeg';
	if (!isJPG) {
		message.error('You can only upload JPG file!');
	}
	const isLt2M = file.size / 1024 / 1024 < 2;
	if (!isLt2M) {
		message.error('Image must smaller than 2MB!');
	}
	return isJPG && isLt2M;
}

class SignUp extends React.Component {
	handleChange = (info) => {
		if (info.file.status === 'uploading') {
			this.setState({ loading: true });
			return;
		}
		if (info.file.status === 'done') {
			// Get this url from response in real world.
			getBase64(info.file.originFileObj, (imageUrl) =>
				this.setState({
					imageUrl,
					loading: false
				})
			);
		}
	};
	handleInputChange(e) {
		//console.log(e);
		//console.log(e);
		this.setState({ isGoing: e });
	}
	handleVisitClick(e) {
		//console.log(e);
		//console.log(e);
		this.setState({ sex: e });
	}
	handleSexClick(e) {
		//console.log(e);
		//console.log(e);
		this.setState({ sex: e });
	}
	handleStateClick(e) {
		this.setState({ state: e });
	}

	setRedirect = () => {
		this.setState({
			redirect: true
		});
	};
	renderRedirect = () => {
		if (this.state.redirect) {
			return <Redirect to="/profile" />;
		}
	};

	handleSignIn = (err, values) => {
		//console.log('data');
		//console.log(err);
		//console.log(values);
		if (!err) {
			var _this = this;
		
		
			//console.log('CALLING IF');
			if (values.avatar) {
				values.avatar = 'https://firebasestorage.googleapis.com/v0/b/curso-demencia.appspot.com/o/avatar-doctor.jpg?alt=media';
			}
			if(values.other === undefined){
				values.other = ""
			}
			if(values.speciality === undefined){
				values.speciality = ""
			}
			if(values.speciality_license === undefined){
				values.speciality_license = ""
			}
			if(values.phone === undefined){
				values.phone = ""
			}
		
			//if(this.state.isGoing == false){
			//if(values.age)
			//this.setState({ sex: values.sex});
			//if(codes.indexOf(values.code) != -1){
			this.setState({  state: values.state });
			//console.log('CALLING LOADER');
			//this.props.showAuthLoader();
			
			this.setState({ values: values });
			/*var age = values.age
			values.age = age.format("DD/MM/YYYY")		*/
			values.email = values.email.trim().toLowerCase()
			
			console.log(values);
			database.collection('users').where('email', '==', values.email).get().then(function(snapshot) {
				if (snapshot.docs.length == 0) {
					//console.log(Moment().format("DD/MM/YYYY'T'hh:mm:ss"))
					if(values.password.length >= 6){
					values.registration_date = Moment().format("DD/MM/YYYY'T'hh:mm:ss")
					
					database
						.collection('users')
						.add(values)
						.then(function(docRef) {
							console.log('WRITING USER DATA DONE');
							_this.props.userSignUp(values);
						})
						.catch(function(error) {
							//console.error('Error adding document: ', error);
						});
				} else {
					console.log('Short Password');
					message.error('La contraseña debe de tener al menos 6 caracteres');

					//_this.props.alertMessage = 'Este usuario ya esta registrado';
				}
			}else{
				message.error('Este usuario ya esta registrado');
			
			}
			});
		//}else{
		//	message.error('Debe aceptar los términos y condiciones');
		//}
	
		} else {
			//console.log('ERROR IS NOT NULL');
		}
	};

	handleSubmit = (e) => {
		e.preventDefault();
		this.props.form.validateFields((err, values) => {
			this.handleSignIn(err, values);
			////console.log(moment(values.birthdate).format('MM/DD/YYYY'));
		});
	};

	constructor() {
		super();
		this.state = {
			loading: false,
			state: 'Aguascalientes',
			sex: 'Masculino',
			redirect: false,
			signing: false,
			values: {}
			//email: 'demo@example.com',
			//password: 'demo#123'
		};
		this.handleSubmit = this.handleSubmit.bind(this);
		this.setRedirect = this.setRedirect.bind(this);
		this.handleSignIn = this.handleSignIn.bind(this);
		this.handleSexClick = this.handleSexClick.bind(this);
		this.handleStateClick = this.handleStateClick.bind(this);
		this.handleVisitClick = this.handleVisitClick.bind(this);
		this.handleInputChange = this.handleInputChange.bind(this);

	}

	componentDidMount() {
		this.setState({ state: 'Aguascalientes', sex: 'Masculino', visit: 'SI', isGoing: true });
	}

	componentDidUpdate() {
		//console.log("V1.233")
		if (this.props.showMessage) {
			setTimeout(() => {
				this.props.hideMessage();
			}, 100);
		}

		//console.log(this.props);
		//console.log(this.state);
		if (!this.state.signing) {
			if (this.props.authUser !== null) {
				auth.onAuthStateChanged((user) => {
					if (user) {
						//console.log('AUTH USER IS ALL RIGHT');
						//this.props.history.push('/');
						//console.log('redirecting...');
						this.setRedirect();
					} else {
						if (this.state.values.email && this.state.values.password) {
							var _this = this;
							this.setState({ signing: true });
							//console.log(this.props.authUser);
							//console.log('AUTH USER IS NOT NUL BUT FIREBASE IS; SIGNING IN....');
							auth
								.signInWithEmailAndPassword(this.state.values.email, this.state.values.password)
								.then((authUser) => {
									this.props.history.push('//');
								})
								.catch((error) => error);
						} else {
							//console.log('EMPTY VALUES');
						}
					}
				});
			} else {
				//console.log('AUTH USER IS NULL');
			}
		}
	}

	render() {
		const { getFieldDecorator } = this.props.form;
		const { showMessage, loader, alertMessage } = this.props;

		const imageUrl = this.state.imageUrl;
		return (
			<div className="gx-app-login-wrap" >
			<HorizontalDefault/>
			<div className="gx-app-login-wrap" id="login-cont">

				<div className="gx-app-login-container">
				
					<div className="gx-app-login-main-content">
						
						{this.renderRedirect()}

						<div className="gx-app-login-content">
						<Row><Col span="6"></Col><Col span="12">		
						 <img alt="example" src={require('assets/images/asset_3.png')} /> 	<br></br>	<br></br>	<br></br>
						</Col><Col span="6"></Col>
					
						</Row>
							{/* <Row>
								<Col span="8" />
								<Col span="8">
									{' '}
								 <img alt="example" src={require('assets/images/asset_3.png')} /> 
								</Col>
								<Col span="8" />
							</Row>
							<br /> */}
							<Form onSubmit={this.handleSubmit} className="gx-signup-form gx-form-row0">
								<Row>
									<Col xl={12} lg={12} md={12} sm={12} xs={12}>
										<FormItem>
											{getFieldDecorator('name', {
												rules: [ { required: true, message: 'Por favor escribe tu nombre' } ]
											})(<Input placeholder="Nombre" />)}
										</FormItem>
										<FormItem>
											{getFieldDecorator('paternal_lastname', {
												rules: [ { required: true, message: 'Ingrese su apellido paterno' } ]
											})(<Input placeholder="Apellido Paterno" />)}
										</FormItem>

										<FormItem>
											{getFieldDecorator('maternal_lastname', {
												rules: [ { required: true, message: 'Ingrese su apellido materno' } ]
											})(<Input placeholder="Apellido Materno" />)}
										</FormItem>
										
										<FormItem>
											{getFieldDecorator('sex', {
												rules: [ { required: true, message: 'Por favor seleccione su sexo' } ]
											})(
												<Select
													name="sex"
													onChange={this.handleSexClick}
													value={this.state.sex}
													placeholder="Sexo"
												>
													<Option value="Masculino">Masculino</Option>
													<Option value="Femenino">Femenino</Option>
												</Select>
											)}
										</FormItem>
										
										<FormItem>
											{getFieldDecorator('phone', {
												rules: [ { required: false, message: 'Ingrese su teléfono celular' } ]
											})(<Input placeholder="Ingrese su teléfono celular" />)}
										</FormItem>	
									
											
								
										
												<FormItem>
											{getFieldDecorator('state', {
												rules: [ { required: true, message: 'Por favor ingrese su estado' } ]
											})(
												<Select
													name="state"
													onChange={this.handleStateClick}
													value={this.state.state}
													placeholder="Estado"
												>
													<Option value="Aguascalientes">Aguascalientes</Option>

													<Option value="Baja California">Baja California</Option>

													<Option value="Baja California Sur">Baja California Sur</Option>

													<Option value="Campeche">Campeche</Option>

													<Option value="Coahuila de Zaragoza">Coahuila</Option>

													<Option value="Colima">Colima</Option>

													<Option value="Chiapas">Chiapas</Option>

													<Option value="Chihuahua">Chihuahua</Option>

													<Option value="Ciudad de México">Ciudad de México</Option>

													<Option value="Durango">Durango</Option>

													<Option value="Guanajuato">Guanajuato</Option>

													<Option value="Guerrero">Guerrero</Option>

													<Option value="Hidalgo">Hidalgo</Option>

													<Option value="Jalisco">Jalisco</Option>

													<Option value="México">México</Option>

													<Option value="Michoacán">Michoacán</Option>

													<Option value="Morelos">Morelos</Option>

													<Option value="Nayarit">Nayarit</Option>

													<Option value="Nuevo León">Nuevo León</Option>

													<Option value="Oaxaca">Oaxaca</Option>

													<Option value="Puebla">Puebla</Option>

													<Option value="Querétaro">Querétaro</Option>

													<Option value="Quintana Roo">Quintana Roo</Option>

													<Option value="San Luis Potosí">San Luis Potosí</Option>

													<Option value="Sinaloa">Sinaloa</Option>

													<Option value="Sonora">Sonora</Option>

													<Option value="Tabasco">Tabasco</Option>

													<Option value="Tamaulipas">Tamaulipas</Option>

													<Option value="Tlaxcala">Tlaxcala</Option>

													<Option value="Veracruz">Veracruz</Option>

													<Option value="Yucatán">Yucatán</Option>

													<Option value="Zacatecas">Zacatecas</Option>
												</Select>
											)}
										</FormItem>
										</Col>
												<Col xl={12} lg={12} md={12} sm={12} xs={12}>
										<FormItem>
											{getFieldDecorator('city', {
												rules: [ { required: true, message: 'Ingrese su ciudad' } ]
											})(<Input placeholder="Ingrese su ciudad" />)}
										</FormItem>	
								
										<FormItem>
											{getFieldDecorator('license', {
												rules: [ { required: true, message: 'Ingrese su cédula profesional' } ]
											})(<Input placeholder="Ingrese su cédula profesional" />)}
										</FormItem>	
										<FormItem>
											{getFieldDecorator('speciality_license', {
												rules: [ { required: false, message: 'Ingrese su Cédula Especialidad o número de miembro del Consejo' } ]
											})(<Input placeholder="Cédula de Especialidad o número de Consejo" />)}
										</FormItem>	
										<FormItem>
											{getFieldDecorator('speciality', {
												rules: [ { required: true, message: 'Por favor seleccione su alta especialidad' } ]
											})(
												<Select
													name="speciality"
													onChange={this.handleSexClick}
													value={this.state.sex}
													placeholder="Alta especialidad"
												>
													<Option value="No aplica">No aplica</Option>
													<Option value="Cornea y Cirugía Refractiva">Cornea y Cirugía Refractiva</Option>
													<Option value="Segmento Anterior">Segmento Anterior</Option>
													<Option value="Estrabismo">Estrabismo</Option>
													<Option value="Glaucoma">Glaucoma</Option>
													<Option value="Neurooftalmología">Neurooftalmología</Option>
													<Option value="Oculoplástica">Oculoplástica</Option>
													<Option value="Visión baja">Visión baja</Option>

													<Option value="Retina y vítreo">Retina y vítreo</Option>
													<Option value="Enfermedades inflamatorias oculares">Enfermedades inflamatorias oculares</Option>
													<Option value="Ultrasonografía ocular">Ultrasonografía ocular</Option>
													<Option value="Oftalmología pediátrica">Oftalmología pediátrica</Option>
													<Option value="Otra">Otra</Option>

												</Select>
											)}
										</FormItem>
										<FormItem>
											{getFieldDecorator('other', {
												rules: [ { required: false, message: 'Ingrese su otra especialidad' } ]
											})(<Input placeholder="Ingrese otra especialidad" />)}
										</FormItem>	
											
								
										{/* <span>Fotografía de perfil</span> */}

										{/* <FormItem>
									{getFieldDecorator('avatar', {
										rules: [
											{
												required: false,
												message: 'Please upload your avatar!'
											}
										]
									})(
										<Upload
											name="avatar"
											listType="picture-card"
											className="avatar-uploader"
											showUploadList={false}
											//action="//jsonplaceholder.typicode.com/posts/"
											beforeUpload={this.beforeUpload}
											onChange={this.handleChange}
										>
											{imageUrl ? <img src={imageUrl} alt="avatar" /> : uploadButton}
										</Upload>
									)}
								</FormItem> */}
										<FormItem>
											{getFieldDecorator('email', {
												rules: [
													{
														required: true,
														type: 'email',
														message: 'The input is not valid E-mail!'
													}
												]
											})(<Input placeholder="Email" />)}
										</FormItem>
										<FormItem>
											{getFieldDecorator('password', {
												rules: [ { required: true, message: 'Por favor escribe tu contraseña' } ]
											})(<Input type="password" placeholder="Password" />)}
										</FormItem>
									</Col>
								</Row>
								<FormItem>
									{getFieldDecorator('remember', {
										rules: [ { required: true, message: 'Debes aceptar los términos y condiciones' } ],
										valuePropName: 'checked',
										initialValue: true
									})(
										<Input
										name="isGoing"
										type="checkbox"
										checked={this.state.isGoing}
										onChange={this.handleInputChange} ></Input>
								
									)}
									
									<span className="gx-link gx-signup-form-forgot">
									<IntlMessages id="appModule.iAccept" />
									<a className="gx-login-form-forgot" href="https://www.cursodeactualizacion-thea.com" target="_blank">	<IntlMessages id="appModule.termAndCondition" /></a>

									
									</span>
								</FormItem>
								
								<FormItem>
									<Button
									id="sesion"
										type="primary"
										className="gx-mb-0"
										htmlType="submit"
										onClick={this.handleSubmit}
									>
										<IntlMessages id="app.userAuth.signUp" />
									</Button>
									<span>
										<IntlMessages id="app.userAuth.or" />
									</span>{' '}
									<Link to="/signin">
										<IntlMessages id="app.userAuth.signIn" />
									</Link>
								</FormItem>
							</Form>
						</div>

						{loader && (
							<div className="gx-loader-view">
								<CircularProgress />
							</div>
						)}
						{showMessage && message.error(alertMessage)}
					</div>
					<span id="version-code">
				{version}</span>
				</div>
				</div>
				{/* <img class="footer-image" src={require("assets/images/ACOMODO-new.png")} alt="thea-academy-mx" title="thea-academy-mx"/> */}
 
			</div>
		);
	}
}

const WrappedSignUpForm = Form.create()(SignUp);

const mapStateToProps = ({ auth }) => {
	const { loader, alertMessage, showMessage, authUser } = auth;
	return { loader, alertMessage, showMessage, authUser };
};

export default connect(mapStateToProps, {
	userSignUp,
	hideMessage,
	userSignIn,
	showAuthLoader,
	userFacebookSignIn,
	userGoogleSignIn,
	userGithubSignIn,
	userTwitterSignIn
})(WrappedSignUpForm);
